export enum LocalStorageKeys {
  UTM = 'sessionUtm',
  LEAD_ID = 'publicAutofinLeadId',
  EXTERNAL_AUTO_ID = 'externalAutoId',
}
